module.exports = __webpack_public_path__ + "img/gold-star.dc4e05a7.jpeg";